// extracted by mini-css-extract-plugin
export default {"general-settings__form-label":"GeneralSettings_general-settings__form-label__S1HL4"};